export class Situacion {

    id: number;
    nombre: string;
    descripcion: string;

    constructor() { }

    static toModel(json: string): Situacion {
        const data = JSON.parse(json);
        const toReturn = new Situacion();

        toReturn.id = data.id;
        toReturn.nombre = data.nombre;
        toReturn.descripcion = data.descripcion;

        return toReturn;
    }

}